<template>

    <div class="containerClass">

        <div class="text-h2">
        🤬
        </div>
        
        <div class="messageClass">
            {{errorMessage}}
        </div>

    </div>

    
   
</template>

<script>

export default{

    data: function(){
        return{
            errorMessage: this.$route.query["errorMessage"]
        }
    }

}
</script>

<style scoped>
.containerClass{
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 10px;
}

.messageClass{
    width: 80%;
    margin-top: 20px
}
</style>